var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_3386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2461 0.980225C5.61849 0.980225 0.246094 6.35262 0.246094 12.9802C0.246094 19.6078 5.61849 24.9802 12.2461 24.9802C18.8737 24.9802 24.2461 19.6078 24.2461 12.9802C24.2461 6.35262 18.8737 0.980225 12.2461 0.980225ZM12.2461 4.28022C14.4001 4.28022 16.1461 6.02623 16.1461 8.18022C16.1461 10.3342 14.4001 12.0802 12.2461 12.0802C10.0921 12.0802 8.34609 10.3342 8.34609 8.18022C8.34609 6.02623 10.0921 4.28022 12.2461 4.28022ZM12.2461 22.5802C8.92209 22.5802 5.99409 20.8906 4.27089 18.3238C5.61609 16.3678 9.90129 15.3802 12.2461 15.3802C14.5909 15.3802 18.8761 16.3678 20.2213 18.3238C18.4981 20.8906 15.5701 22.5802 12.2461 22.5802Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_3386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.246094 0.980225)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default_avatar.461f7df0fb2b14ca1d26716554f325f4.svg";
export { ForwardRef as ReactComponent };